import { readCollection, readExperimental } from './read'
import { createResourceObject } from './resourceObject'

export const plans = {
  readCollection,
  readSingle: readExperimental,
  resourceObject: createResourceObject,
}
